import addObjectTemplate from './add-object.html';

angular.module('org.saga.addobject', [
   'org.saga.service'
])

   .factory('AddObjectDialog', ['$mdDialog', '$log', function($mdDialog, $log) {

      return {
         show: function(title, message, callback) {
            function DialogController($scope, $log, $mdDialog) {

               $scope.title = title;
               $scope.message = message;
               $scope.namePattern = '[a-zA-Z0-9]+';

               $scope.newObject = { name: '', label: '' };

               $scope.cancel = function() {
                  $mdDialog.cancel();
               };

               $scope.ok = function() {
                  $log.info($scope.newObject);
                  $mdDialog.hide($scope.newObject);
               };
            }

            $mdDialog.show({
               controller: ['$scope', '$log', '$mdDialog', DialogController],
               template: addObjectTemplate,
               parent: angular.element(document.body),
               clickOutsideToClose: true
            })
               .then(function(answer) {
                  $log.info(answer);
                  callback(answer);
               }, function() {
                  // callback is not called
               });

         }
      };
   }]);
